import { UserType } from '@inplay/models';
import { PropsWithChildren, useMemo, useState } from 'react';
import { AuthTokenResponse } from '../../service/service.type';
import Search from '../../component/search/search';
import Setting from '../../assets/setting.png';
import { validateAndDecodeAuthToken } from '../../utils/helper';
import ActionButton from '../../component/button/button';
import { Trans } from 'react-i18next';
import DatePicker from '../../component/datePicker/datePicker';
import { Mode } from '../../component/datePicker/datePicker.type';
import {
  getSettingsMenuForUser,
  renderSettingsMenuWithDropdown,
} from '../userManagement/userManagementHelper';
import { SweepsTableHeaderProps } from './sweeps.type';
import { renderActionButtons } from './sweepHelper';

export const SweepsTableHeader = <AddOption extends string = string>({
  searchQuery,
  handleOnChangeSearch,
  onSettingMenuSelect,
  children,
  selectedDate,
  handleSelectedDate,
  disableSettingMenu,
  selectedCount,
  reportLabel,
  handleClose,
  handleDelete,
  handleDownload,
  handleApprove,
  showDownloadLoading,
}: PropsWithChildren<SweepsTableHeaderProps<AddOption>>) => {
  const [isOpenSettingMenu, setIsOpenSettingMenu] = useState<boolean>(false);

  const userType: UserType | undefined = useMemo(() => {
    const validAuthToken: AuthTokenResponse | null =
      validateAndDecodeAuthToken();
    return validAuthToken?.type as UserType | undefined;
  }, []);
  return (
    <div className="flex items-center justify-between pl-10 pr-8">
      <div className="flex">
        {/* single date picker */}
        {selectedCount > 0 ? (
          renderActionButtons(
            selectedCount,
            reportLabel ?? '',
            handleClose,
            handleDelete,
            handleDownload,
            showDownloadLoading,
          )
        ) : (
          <DatePicker
            mode={Mode.Single}
            handleApply={(range) => {
              if (range?.from && handleSelectedDate) {
                handleSelectedDate(range.from);
              }
            }}
            finalRange={{
              from: selectedDate,
              to: selectedDate,
            }}
            className="top-[165px]"
          />
        )}
      </div>

      {/* display approve button  */}
      <div className="flex">
        {userType !== UserType.VENUE_ADMIN &&
          userType !== UserType.VENUE_BRANCH_LOGIN && (
            <ActionButton
              className="ml-2 w-9/12 rounded-full text-sm bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR"
              onClick={handleApprove}
            >
              <Trans i18nKey="sweeps.approveReport" />
            </ActionButton>
          )}

        <Search
          query={searchQuery}
          onChange={handleOnChangeSearch}
          placeholder="Search"
          iconSize={13}
          iconRight={false}
          id="custom-search"
          containerClass="w-22 ml-3 mr-3"
          inputClass="text-sm"
        />
        {children}
        {renderSettingsMenuWithDropdown(
          Setting,
          isOpenSettingMenu,
          () => setIsOpenSettingMenu((prev) => !prev),
          getSettingsMenuForUser(userType),
          (label: string | undefined) => onSettingMenuSelect?.(label),
          disableSettingMenu,
        )}
      </div>
    </div>
  );
};
